import { TableBody, TableColumnContainer, TableColumnView, TableView } from "components/shared";
import React from "react";

import "./styles.css";
import NonNachaTemplateListTableRow from "../NonNachaTemplateListTableRow";
import { NoEntriesTableRow } from "components/shared/views/TableView/components/NoEntriesTableRow";

/**
 * @function NonNachaTemplateListTable
 * @return {React.Component}
 * @exported true
 * @description This is the non nacha template table for NonNachaTemplateListWidget
 */
export default function NonNachaTemplateListTable(props) {
    return (
        <TableView className="non-nacha-template-list-table">
            <TableColumnContainer className="hide" >
                <TableColumnView className="template-name-col" text="Template Name" />
                <TableColumnView className="transaction-type-col" text="Transaction Type" />
                <TableColumnView className="edit-col text-center" text="Edit" />
                <TableColumnView className="delete-col text-center" text="Delete" />
            </TableColumnContainer>
            <TableBody>
                {/* <NonNachaTemplateListTableRow /> */}
                <NoEntriesTableRow text="You do not have any templates setup. Please choose a file above to create a new template." colSpan="4" />
            </TableBody>
        </TableView>
    )
}
